import {
  ComplexityLevel,
  CompletionCriterion,
  PropaedeuticLogic,
  TestLogic,
} from "../types";

export interface SelectOption<TValue extends string> {
  value: TValue;
  i18nKey: string;
}

export const PROPAEDEUTIC_LOGICS_OPTIONS: SelectOption<PropaedeuticLogic>[] = [
  { value: "FIRST", i18nKey: "options.propaedeutic_logics.first" },
  { value: "FREE", i18nKey: "options.propaedeutic_logics.free" },
  { value: "SEQUENTIAL", i18nKey: "options.propaedeutic_logics.sequential" },
  { value: "LAST_LOCKED", i18nKey: "options.propaedeutic_logics.last_locked" },
];

export const COMPLETION_CRITERION_OPTIONS: SelectOption<CompletionCriterion>[] =
  [
    { value: "LO_TO_COMPLETE", i18nKey: "options.completion.lo_to_complete" },
    {
      value: "MIN_COMPLETION_PERC",
      i18nKey: "options.completion.min_completion_perc",
    },
    {
      value: "COMPLETION_MINUTES",
      i18nKey: "options.completion.completion_minutes",
    },
    {
      value: "COMPLETION_MINUTES_PERC",
      i18nKey: "options.completion.completion_minutes_perc",
    },
  ];

export const COMPLEXITY_OPTIONS: SelectOption<ComplexityLevel>[] = [
  { value: "BASE", i18nKey: "options.complexity.base" },
  { value: "MEDIUM", i18nKey: "options.complexity.medium" },
  { value: "ADVANCED", i18nKey: "options.complexity.advanced" },
];

export const TEST_LOGIC_OPTIONS: SelectOption<TestLogic>[] = [
  { value: "WITH_ZEROING", i18nKey: "options.test_logic.with_zeroing" },
  { value: "FREE", i18nKey: "options.test_logic.free" },
];
